import React from 'react';

// Icono de refresh con el mismo azul y tamaño que NewChatIcon
const RefreshBlueIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Círculo de flecha */}
    <path d="M7 2.5a4.5 4.5 0 1 1-4.5 4.5" stroke="#0074D4" strokeWidth="1.2" fill="none"/>
    {/* Flecha */}
    <path d="M2.5 2.5V6h3.5" stroke="#0074D4" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
  </svg>
);

export default RefreshBlueIcon;
